import Vue from 'vue';
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import Vuetify from 'vuetify'
import locale from 'element-ui/lib/locale/lang/en'
import BlockUIService from './Shared/BlockUIService.js';
import App from './App.vue';
import Layout from './components/Layout/Layout.vue';
import Login from './components/Login/Login.vue';
import Home from './components/Home/Home.vue';
import DataService from './Shared/DataService';
import Helper from './Shared/Helper';

import Users from './components/Users/Users.vue';
import Profile from './components/Users/EditUsersProfile/EditUsersProfile.vue'


import patient from "./components/patient/patient.vue"
import AddPatient from "./components/patient/Add/Add.vue"
import PatientTransacitons from "./components/patient/Transactions/Transactions.vue"
import PatientTransfer from './components/patient/TransferRequest/TransferInfo.vue';
import PatientTransferRequest from './components/patient/TransferRequest/Add/TransferRequest.vue';
import PatientTransferRequestCenter from './components/patient/TransferRequest/CenterChangeRequest/TransferRequest.vue';
import PatientDailyUsed from "./components/patient/DailyUsed/DailyUsed.vue";
import PatientDailyUsedReport from "./components/patient/DailyUsedReport/DailyUsedReport.vue";
import Required from "./components/patient/DailyUsedRequired/DailyUsedRequired.vue";


import company from './components/company/company.vue';
import Devices from './components/company/Devices/Devices.vue';
import Filters from './components/company/Filters/Filters.vue';

import KidneyCenters from './components/KidneyCenters/KidneyCenters.vue';
import KidneyCentersDevices from './components/KidneyCenters/Devices/Devices.vue';
import Municipalities from './components/KidneyCenters/Municipalities/Municipalities.vue';
import Cities from './components/KidneyCenters/Cities/Cities.vue';
import Nationalites from './components/KidneyCenters/Nationalites/Nationalites.vue';






import VueEllipseProgress from 'vue-ellipse-progress';

Vue.use(VueEllipseProgress);

Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;
Vue.prototype.$helper = Helper;

export const eventBus = new Vue();

//const i18n = new VueI18n({
//    locale: 'ar', // set locale
//    messages, // set locale messages
//})

const router = new VueRouter({
    mode: "history",
    base: __dirname,
    linkActiveClass: "active",
    routes: [
        {
            path: "/Login",
            component: Login,
        },
        {
            path: "/",
            component: App,
            children: [
                {
                    path: "",
                    component: Layout,
                    children: [
                        { path: "", component: Home },
                        { path: "patient", component: patient },
                        { path: "AddPatient", component: AddPatient },
                        { path: "PatientTransacitons", component: PatientTransacitons },
                        { path: "PatientTransfer", component: PatientTransfer },
                        { path: "PatientTransferRequest", component: PatientTransferRequest },
                        { path: "PatientTransferRequestCenter", component: PatientTransferRequestCenter },
                        { path: "PatientDailyUsed", component: PatientDailyUsed },
                        { path: "PatientDailyUsedReport", component: PatientDailyUsedReport },
                        { path: "Required", component: Required, },

                        { path: "company", component: company },
                        { path: "Devices", component: Devices },
                        { path: "Filters", component: Filters },

                        { path: "KidneyCentersDevices", component: KidneyCentersDevices },
                        { path: "KidneyCenters", component: KidneyCenters },
                        { path: "Municipalities", component: Municipalities },
                        { path: "Cities", component: Cities },
                        { path: "Nationalites", component: Nationalites },

                        { path: "Users", component: Users },
                        { path: "Profile", component: Profile },

                        
                    ],
                },
            ],
        },
    ],
});

Vue.filter("toUpperCase", function (value) {
    if (!value) return "";
    return value.toUpperCase();
});

new Vue({
    router,
    render: (h) => {
        return h(App);
    },
}).$mount("#cpanel-management");
